// extracted by mini-css-extract-plugin
export var button = "Button-module--button--094fe";
export var buttonDark = "Button-module--buttonDark--b2dbb";
export var buttonLight = "Button-module--buttonLight--f6148";
export var button_InputDark = "Button-module--button_InputDark--04465";
export var button_InputLight = "Button-module--button_InputLight--90b06";
export var button_Input_shyne = "Button-module--button_Input_shyne--5cf4a";
export var button_shine = "Button-module--button_shine--de32d";
export var shine = "Button-module--shine--4bc45";